// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import Button from '@atlaskit/button';
import { N500, R400, R50 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledValue = styled.span({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':not(:only-child)': {
		marginRight: token('space.050', '4px'),
	},
	marginLeft: token('space.050', '4px'),
	maxWidth: `${8 * 25}px`,
	textOverflow: 'ellipsis',
	display: 'inline-block',
	overflow: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LoadingWrapper = styled.div({
	display: 'flex',
	justifyContent: 'center',
	margin: `${token('space.075', '6px')} 0`,
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledBox = styled.div<{ height?: number; iconSize?: number }>`
	align-items: center;
	display: flex;
	flex-direction: column;
	height: ${(props: any) => (props.height ? props.height : 128)}px;
	justify-content: center;

	${({ iconSize }) =>
		iconSize
			? `svg {
        width: ${iconSize}px;
        height: ${iconSize}px;
      }`
			: ''}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledText = styled.div({
	marginTop: token('space.100', '8px'),
	maxWidth: '248px',
	textAlign: 'center',
	color: token('color.text.subtle', N500),
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InvalidButton = styled(Button)`
	color: ${token('color.text.danger', R400)} !important;
	background-color: ${token('color.background.danger.hovered', R50)} !important;

	&:hover,
	&:focus {
		color: ${token('color.text.danger', R400)} !important;
		background-color: ${token('color.background.danger.hovered', R50)} !important;
	}
`;
